import slide1 from '../../assets/images/home-slider01.jpg'
import slide2 from '../../assets/images/home-slider02.jpg'
import slide3 from '../../assets/images/home-ic_back.png'
import slide4 from '../../assets/images/home-back-svg.png'
import prev from '../../assets/images/prev.png'
import back from '../../assets/images/back.png'
import '../../assets/css/slider.css'

export default function Slider() {
  return (
    <div className='slider'>
      <div id="carouselExample" class="carousel slide overflow-hidden">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="d-block w-100" src={slide2} alt="Second slide" />
            <div class="app-Development">
              <h3>app  Development</h3>
            </div>
            <div class="web-Development">
              <h3>web/saas  Development</h3>
            </div>
            <div class="UI-Design">
              <h3>UI/UX  Design</h3>
            </div>
            <div class="slider-right-text">
              <h2 class="wow bounceInLeft visible">Get <br></br> Marketing <span><br></br>Expert</span></h2>
              <p>Helping quality conscious companies to Design, Develop, and Expand their Business through Digital
                Products. </p>
            </div>
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src={slide1} alt="First slide" />
            <div class="slider-left-text d-md-block">
              <h3 class="wow fadeInLeft">Solve Business Challenge</h3>
              <h2 class="wow bounceInLeft"><span>innovative</span> IT <br></br> Company</h2>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <img src={prev} className='img' style={{ maxWidth: '40%' }} />
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <img src={back} className='img' style={{ maxWidth: '40%' }} />     
            <span class="visually-hidden">Next</span>
          </button>
        </div>

      </div>


      {/* <div class="">
        <div id="carouselExampleControls" class="carousel slide  slider overflow-hidden">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100" src={slide1} alt="First slide" />
              <div class="slider-left-text d-md-block">
                <h3 class="wow fadeInLeft">Solve Business Challenge</h3>
                <h2 class="wow bounceInLeft"><span>innovative</span> IT  Company</h2>
              </div>
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src={slide2} alt="Second slide" />
              <div class="app-Development">
                <h3>app  Development</h3>
              </div>
              <div class="web-Development">
                <h3>web/saas  Development</h3>
              </div>
              <div class="UI-Design">
                <h3>UI/UX  Design</h3>
              </div>
              <div class="slider-right-text d-md-block">
                <h2 class="wow bounceInLeft">Get  Marketing <span>Expert</span></h2>
                <p>Helping quality conscious companies to Design, Develop, and Expand their Business through Digital
                  Products. </p>
              </div>
            </div>
          </div>

          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-slide="prev">
            <img src={slide3} />
            <span class="sr-only">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-slide="next">
            <img src={slide4} />
            <span class="sr-only">Next</span>
          </button>
        </div>
      </div> */}
    </div>
  )
}